import { Button } from "@egaranti/components";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import FilterSelect from "./FilterSelect";

import useExtendedWarrantyStore from "@/stores/useExtendedWarranty";

import DateRangePicker from "@/components/ui/dateRangePicker";

import FilterIcon from "@/assets/icons/filter.svg?react";

import { RotateCcw } from "lucide-react";

const SaleReportFilters = ({ filters, onFilterChange, onResetFilters }) => {
  const { t } = useTranslation();
  const { filterData, getFilterData } = useExtendedWarrantyStore();
  const { stores, packageTypes, categories, loading } = filterData;

  useEffect(() => {
    getFilterData();
  }, []);

  const hasActiveFilters =
    filters.dateRange?.from ||
    filters.dateRange?.to ||
    filters.category ||
    filters.store ||
    filters.plan;

  return (
    <div className="mb-6">
      <div className="rounded-lg border bg-white p-4">
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <FilterIcon className="h-5 w-5 text-[#677389]" />
            <span className="font-medium text-[#111729]">
              {t("extendedWarranty.reports.filters.title", "Filtreler")}
            </span>
          </div>
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onResetFilters}
              className="flex items-center gap-2 text-[#677389] hover:bg-gray-50 hover:text-[#111729]"
            >
              <RotateCcw className="h-4 w-4" />
              {t(
                "extendedWarranty.reports.filters.reset",
                "Filtreleri Sıfırla",
              )}
            </Button>
          )}
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-[#111729]">
              {t(
                "extendedWarranty.reports.filters.dateRange",
                "Tarih Aralığı",
              )}
            </label>
            <DateRangePicker
              dateRange={filters.dateRange}
              onChange={(dateRange) => onFilterChange({ dateRange })}
            />
          </div>
          <FilterSelect
            label={t("extendedWarranty.reports.filters.category", "Kategori")}
            value={filters.category}
            onValueChange={(category) => onFilterChange({ category })}
            placeholder={t(
              "extendedWarranty.reports.filters.categoryPlaceholder",
              "Kategori seçin",
            )}
            options={categories}
            disabled={loading}
            className=""
          />

          <FilterSelect
            label={t("extendedWarranty.reports.filters.store", "Mağaza")}
            value={filters.store}
            onValueChange={(store) => onFilterChange({ store })}
            placeholder={t(
              "extendedWarranty.reports.filters.storePlaceholder",
              "Mağaza seçin",
            )}
            options={stores}
            disabled={loading}
            className=""
          />

          <FilterSelect
            label={t(
              "extendedWarranty.reports.filters.planType",
              "Paket Tipi",
            )}
            value={filters.plan}
            onValueChange={(plan) => onFilterChange({ plan })}
            placeholder={t(
              "extendedWarranty.reports.filters.planTypePlaceholder",
              "Paket tipi seçin",
            )}
            options={packageTypes}
            disabled={loading}
            className=""
          />
        </div>
      </div>
    </div>
  );
};

export default SaleReportFilters;
